// extracted by mini-css-extract-plugin
module.exports = {"facets-container":"search-filters-desktop_facets-container__ziHAh"};